<template>
  <div class="cp-set-handle main">
    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-at icon" />Handle
        <span class="is-pulled-right has-text-link">
          {{ parsed || "*" }}.tukapp.co</span
        >
      </p>
      <div style="margin-top: 10px">
        <input class="input" v-model="handle" spellcheck="false" />
      </div>
      <p class="hint">
        Enter a handle for your shop. This will be used in URLs like
        <a>handle.tukapp.co</a> and <a>tukapp.co/@handle</a> <br />It should be
        short and similar to your shop's name. <br />Once set it can't be
        changed, so choose wisely.
      </p>
      <!-- only show save if no handle yet or superuser -->
      <div class="save-wrapper">
        <p class="button has-text-success" @click="presaveHandle">Save</p>
      </div>
    </div>

    <!-- <div v-if="$store.getters.isSuperUser" class="superuser">
      <div class="divider" />

      <div class="row">
        <p><i class="fa fa-tags icon" />Search Terms</p>
        <div style="margin-top: 10px">
          <input
            class="input"
            v-model="searchTerms"
            placeholder="Search terms..."
          />
        </div>
        <div class="save-wrapper">
          <p v-if="updatingSearchTerms" class="button">
            <i class="fa fa-spinner fa-spin" />
          </p>
          <p v-else class="button has-text-success" @click="saveSearchTerms">
            Save
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>


<script>
export default {
  name: "CPSetShopName",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      handle: null,
      updatingHandle: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    parsed() {
      if (!this.handle) return "";
      var parsed = this.handle.replace(/[^A-Z0-9]/gi, "");
      return parsed.toLowerCase();
    },
  },
  mounted() {
    this.handle = this.business.data.premium_link;
  },
  methods: {
    presaveHandle() {
      if (!this.parsed || this.parsed.length < 3) {
        var msg = "Handle is too short<br>Must be 3+ characters";
        this.errorToast(msg, "top");
        return;
      }
      this.$confirm({
        message: `Confirm handle: ${this.parsed}`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) this.saveShortLink();
        },
      });
    },
    saveShortLink() {
      var longShopURL = `/shop/${this.business.id}`;
      var shortLinkID = "@" + this.parsed; // parsed removes any special chars
      var validity = 60 * 24 * 365 * 99; // valid for 99 years
      //   this.shortenLink(longShopURL, shortLinkID, validity);
      var loader = this.loadingDots("yellow");
      this.$store
        .dispatch("createShortLink", {
          url: longShopURL,
          short_id: shortLinkID,
          validity: validity, // in minutes, 60*24 = 1 day
        })
        .then(() => this.saveHandle())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    saveHandle() {
      var shortLinkID = "@" + this.parsed; // parsed removes any special chars
      var obj = { premium_link: shortLinkID };
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated!");
          this.business.data = res.data.data; // set it locally, or better, update the whole business
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.superuser .row {
  background-color: #eef;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
